<template>
  <div v-if="files.length > 0" class="flex flex-wrap gap-1 p-2 bg-white">
    <div 
      v-for="file in files" 
      :key="file.id" 
      class="flex items-center gap-1 px-2 py-1 bg-gpx_gray-900 rounded-md border border-gpx_gray-800 text-xs"
    >
      <div v-if="file.status === 'uploading'" class="w-3 h-3 border border-blue-500 border-t-transparent rounded-full animate-spin"></div>
      <div v-else-if="file.status === 'success'" class="w-3 h-3 text-green-500">
        <svg fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
      </div>
      <div v-else-if="file.status === 'error'" class="w-3 h-3 text-gpx_terracotta-100">
        <svg fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </div>
      <span class="text-gpx_gray-600 truncate max-w-24">{{ file.name }}</span>
      <button
        @click="handleRemoveFile(file.id)"
        class="text-gpx_gray-700 hover:text-gpx_terracotta-100 p-0.5 rounded"
        :disabled="file.status === 'uploading'"
      >
        <svg class="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd" />
        </svg>
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  files: {
    type: Array,
    required: true
  }
});

const emit = defineEmits(['remove-file']);

const handleRemoveFile = (fileId) => {
  emit('remove-file', fileId);
};
</script> 